import KitEmbalagemModel from "../models/kitEmbalagemModel";
import nfetch from "../utils/events/nfetch";

import { iServiceCached } from "./base/iServiceCached";

class KitEmbalagemService extends iServiceCached<KitEmbalagemModel> {
    constructor() {
        super("KitEmbalagem");
    }

    public getKitByRecipiente(produtoRecipienteId: number, formaFarmaceuticaId?: number): Promise<Response> {
        return nfetch(
            `/${this.controllerName}/GetKitByRecipiente?produtoRecipienteId=${produtoRecipienteId}&formaFarmaceuticaId=${formaFarmaceuticaId}`,
            {
                credentials: "same-origin",
            },
        );
    }

    public replicar(id: number, idFranquias: string): Promise<Response> {
        return nfetch(`/${this.controllerName}/Replicar?id=${id}&idFranquias=${idFranquias}`, {
            method: "post",
            credentials: "same-origin",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
            },
        });
    }

    public getByParent(parentId: number, franquiaId: number): Promise<Response> {
        //@ts-ignore
        return nfetch(`/${this.controllerName}/GetByParentId?parentId=${parentId}&franquiaId=${franquiaId}`, {
            credentials: "same-origin",
        })
            .then((response: Response) => {
                if (response.ok) {
                    return response;
                }
            })
            .catch(error => {});
    }

    public getByEstoqueId(estoqueId: number): Promise<Response> {
        return nfetch(`/${this.controllerName}/GetByEstoqueId?estoqueId=${estoqueId}`, {
            credentials: "same-origin",
        });
    }

    public async comboCached(franquiaId: number) {
        const retorno = await this.combo(franquiaId);
        return retorno.map(p => ({
            value: p.id,
            text: `${p.descricao}` + (p.ativo ? "" : " - [INATIVO]"),
            ativo: p.ativo,
        }));
    }
}

export default new KitEmbalagemService();
